import React, { useState, useEffect } from "react";
import { loginRequest } from "../authConfig";
import { useMsal } from "@azure/msal-react";
import { callMsGraph } from "../graph";
import { fetchWithRetry } from "../utils/graphApi";
import ProfileDropdown from "./ProfileDropdown";

function UserProfile() {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);
  const [profileImage, setProfileImage] = useState(null);

  useEffect(() => {
    if (accounts.length > 0) {
      instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        .then((response) => {
          callMsGraph(response.accessToken).then((data) => {
            setGraphData(data);
            try {
              window.__currentUserDisplayName = data?.displayName || '';
            } catch (e) {
              // noop
            }
          });

          fetchWithRetry(
            "https://graph.microsoft.com/v1.0/me/photo/$value",
            { headers: { Authorization: `Bearer ${response.accessToken}` } },
            3,
            false
          )
            .then((res) => {
              if (!res || !res.ok) throw new Error("No profile photo");
              return res.blob();
            })
            .then((blob) => {
              setProfileImage(URL.createObjectURL(blob));
            })
            .catch(() => {
              setProfileImage(null);
            });
        })
        .catch((error) => console.error("Error fetching profile data:", error));
    }
  }, [accounts, instance]);

  return (
    <ProfileDropdown
      displayName={graphData?.displayName || ""}
      jobTitle={graphData?.jobTitle || ""}
      email={graphData?.mail || graphData?.userPrincipalName || ""}
      profileImage={profileImage}
      variant="desktop"
    />
  );
}

export default UserProfile;
